// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__eCGS5","selects":"Documents_selects__1eRKM"};